export default __webpack_public_path__ + "static/media/hero-bg-03.dbd92ebc.jpg";